import { define } from 'wicked-elements'
import Flickity from 'flickity'
import 'flickity/dist/flickity.min.css'

define('[data-component~="slider"]', {
  init () {
    this.$slider = this.element.querySelector('[data-slider]')
    this.$caption = this.element.querySelector('[data-figcaption]')
    this.count = this.$slider.children.length
    this.loadImage = this.loadImage.bind(this)
  },
  initFlickity () {
    this.flkty = new Flickity(this.$slider, {
      pageDots: false,
      arrowShape: 'M39.91 10.09 L0 50 L39.91 89.91 L65.61 89.91 L34.27 59.27 L100 59.27 L100 40.73 L34.27 40.73 L65.61 10.09 L39.91 10.09 Z',
      adaptiveHeight: true,
      wrapAround: true
    })

    this.flkty.on('change', () => {
      const selected = this.flkty.selectedElement
      this.$caption.innerHTML = selected.dataset.caption || ''
    })

    // force Ultralazy images to load 
    this.flkty.on('select', this.loadImage)
    setTimeout(() => {
      this.loadImage()
    })
  },
  loadImage () {
    const selected = this.flkty.selectedElement
    const img = selected.querySelector('img')
    if (img) {
      img.dispatchEvent(new CustomEvent('triggerLoad'))
    }
  },
  connected () {
    if (this.count > 1) {
      this.initFlickity()
    }
  },
  disconnected () {
    if (this.flkty) {
      this.flkty.destroy()
    }
  }
})